import { Switch } from '@mui/material'
import { useColorScheme } from '@mui/material/styles'
import type { FC } from 'react'
import { t } from 'ttag'

const ColorModeToggle: FC = () => {
  const { mode, setMode } = useColorScheme()
  if (!mode) {
    return null
  }

  const handleToggle = () => {
    setMode(mode === 'dark' ? 'light' : 'dark')
  }

  return (
    <Switch
      checked={mode === 'dark'}
      onChange={handleToggle}
      slotProps={{ input: { 'aria-label': t`Toggle color mode` } }}
    />
  )
}

export default ColorModeToggle
